
import React, { Suspense, lazy } from 'react';
import Navbar from '@/components/Navbar';
import HeroSection from '@/components/HeroSection';
import FeaturesSection from '@/components/FeaturesSection';
import HowItWorksSection from '@/components/HowItWorksSection';
import RegistrationSection from '@/components/RegistrationSection';
import Footer from '@/components/Footer';
import SignupPromotionFallback from '@/components/SignupPromotionFallback';

// Lazy load the SignupPromotion component with framer-motion
const SignupPromotion = lazy(() => import('@/components/SignupPromotion').catch(() => {
  console.warn('Failed to load SignupPromotion with framer-motion, using fallback instead');
  return { default: SignupPromotionFallback };
}));

const ComingSoon = () => {
  return (
    <div className="min-h-screen bg-black text-white">
      <Navbar />
      <Suspense fallback={<SignupPromotionFallback />}>
        <SignupPromotion />
      </Suspense>
      <HeroSection />
      <FeaturesSection />
      <HowItWorksSection />
      {/* <RegistrationSection /> */}
      <Footer />
    </div>
  );
};

export default ComingSoon;
